import config from "../config/env";
import StackdriverErrorReporter from "stackdriver-errors-js";
import { IS_PROD } from "./constants";
import packageJson from "../../package.json";
const { version } = packageJson;

/*
 * The last three are how Safari, Chromium and Firefox word a request the device never completed
 * (tab suspended, phone locked, signal lost). They say nothing about our code or servers, and the
 * message pages poll every ten seconds, so every backgrounded phone would file one.
 */
const ERRORS_NOT_TO_BE_REPORTED_TO_GCP = [
  "Password is too common",
  "Unauthenticated",
  "Incorrect login or password",
  "Load failed",
  "Failed to fetch",
  "NetworkError when attempting to fetch resource"
];

export function graphQLError() {
  alert("An error has occurred.");
}

export async function reportError(error: Error | string, stack?: string) {
  if (!stack) {
    stack = new Error().stack;
  }

  const ignoreReporting = ERRORS_NOT_TO_BE_REPORTED_TO_GCP.some(errorToIgnore => {
    if (typeof error === "string" || error instanceof String) {
      return error.includes(errorToIgnore);
    } else {
      return error.message?.includes(errorToIgnore);
    }
  });

  if (!ignoreReporting) {
    if (IS_PROD) {
      const errorHandler = new StackdriverErrorReporter();
      errorHandler.start({
        key: config.env.REACT_APP_GCP_ERROR_REPORTING_API_KEY,
        projectId: config.env.REACT_APP_GCP_PROJECT_ID,
        service: "web"
      });
      const userIdStr = sessionStorage.getItem("userId");
      const userId = userIdStr ? parseInt(userIdStr) : "unknown";
      errorHandler.report(`userId: ${userId} | version: ${version} | error: ${error} | stack: \n${stack}`);
    } else {
      console.log(`ERROR REPORTED: ${error} | stack: \n${stack}`);
    }
  }
}
